/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { EEcmPanelStatus } from '../../models';
import { ELayoutActions, LayoutActions } from '../actions';
import { EEcmPanelActionTypes, EcmPanelActions } from '../actions/ecm-panel.actions';
import { IEcmPanelState, initialEcmPanelState } from '../state';

export function ecmPanelReducer(state = initialEcmPanelState, action: LayoutActions | EcmPanelActions): IEcmPanelState {
  switch (action.type) {
    // Opening the panel (or switching to another vehicle) starts a fresh load.
    case ELayoutActions.OpenEcmPanel:
      return {
        ...state,
        vehicleName: action.payload.vehicleName,
        vehicleId: action.payload.vehicleId,
        plotType: action.payload.plotType,
        status: EEcmPanelStatus.Loading,
        diagnostics: null,
        diagnosticsErrors: []
      };

    // Load finished with no errors: the side panel is now open with data.
    case EEcmPanelActionTypes.LoadDiagnosticsSuccessAction:
      return {
        ...state,
        status: EEcmPanelStatus.Open,
        diagnostics: action.payload,
        diagnosticsErrors: []
      };

    // Real-time socket update: refresh the displayed diagnostics without touching loading/error flags.
    case EEcmPanelActionTypes.UpdateDiagnosticsAction:
      return {
        ...state,
        diagnostics: action.payload
      };

    // Load finished with errors: the panel is still open so it can surface them.
    case EEcmPanelActionTypes.LoadDiagnosticsErrorAction:
      return {
        ...state,
        status: EEcmPanelStatus.Open,
        diagnostics: null,
        diagnosticsErrors: action.payload.errors
      };

    // Closing the panel (the side-panel X) clears the diagnostics and returns to the initial CLOSED state.
    case EEcmPanelActionTypes.CloseEcmPanelAction:
      return initialEcmPanelState;

    default:
      return state;
  }
}
